import Vue from 'vue';
import Auth0 from '@eui-util/auth0-plugin';
import EUINotifications from '@eui-plugin/event-bus-notifications';
import './styles/icons/style.css';
import * as Constants from './utils/constants';
import { hydrateWidget, verifyWidgetProps } from './utils/hydrate-widget';
import store from './store';
import MainApp from './main-app.vue';
import { getEnv } from 'ecx.saigon.ui.common';
import ParseDateFilter from './filters/parse-date-filter';
import mock from './utils/hydrate-widget/mock';
import { Notify, Dialog } from 'quasar';
import Eclipx from '@eui-plugin/vue-eclipx';
import { euiThemes } from '@eui-mixin/theme';

export default async function (initialProps = Constants.DEFAULT_WIDGET_PROPS) {
  Vue.config.productionTip = false;

  const env = await getEnv();

  const useMock = initialProps.useMock || env.VUE_APP_USE_MOCK;

  if (useMock) {
    initialProps = mock;
  }

  // Extend the vue prototype constants
  Vue.prototype.$Constants = {
    ...Vue.prototype.$Constants,
    ...Constants
  };

  // Install the base Eclipx UI plugin
  Vue.use(Eclipx, {
    theme: euiThemes.customer,
    quasar: {
      plugins: {
        Notify,
        Dialog
      }
    }
  });

  Vue.use(EUINotifications);
  Vue.filter('ParseDateFilter', ParseDateFilter);

  const {
    VUE_APP_AUTH_DOMAIN: domain,
    VUE_APP_AUTH_CLIENT_ID: clientId,
    VUE_APP_AUTH_REALM: connection
  } = await getEnv();

  if (!Vue.prototype.$auth) {
    Vue.use(Auth0, {
      domain,
      clientId,
      connection
    });
  }

  verifyWidgetProps(initialProps);
  hydrateWidget(initialProps);

  new Vue({
    store,
    render: (h) => h(MainApp)
  }).$mount(initialProps.mountSelector);
}
